import isEmpty from "lodash/isEmpty";

import "../stylesheets/styles.scss";
import "../javascripts/lib/flash-message";
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import Rails from 'rails-ujs';
import React from 'react';
import { createRoot } from 'react-dom/client';
// sortablejs は商品画像編集画面でしか使わないため動的 import
import { WowmaCategories } from "../javascripts/WowmaCategories";
import SearchBox from "../javascripts/SearchBox";
import SearchInput from "../javascripts/SearchInput";
import SearchRange from "../javascripts/SearchRange";
import SearchDateRange from "../javascripts/SearchDateRange";
import SearchDate from "../javascripts/SearchDate";
import SearchOrder from "../javascripts/SearchOrder";
import SearchSubmit from "../javascripts/SearchSubmit";
import '../javascripts/draw-histories';
import '../javascripts/clipboard';
import '../javascripts/csvs';
Rails.start();
window.Rails = Rails;
import "../javascripts/lib/sidebar";
import FilterCheckbox from "../javascripts/FilterCheckbox";
import DatePicker from "../javascripts/DatePicker";
import DataViewer from "../javascripts/DataViewer";
import { csrfHeader, csrfToken, normalizeKanji, showLoader } from "../javascripts/lib/utils";
import SearchSelect from "../javascripts/SearchSelect";
import SearchCategory from "../javascripts/SearchCategory";
import "chartkick/chart.js"
import copy from 'clipboard-copy';
import debounce from 'lodash/debounce';
import chunk from "lodash/chunk";
import { RemoteIslandsForm } from "../javascripts/RemoteIslandsForm";
import { NgBuyersForm } from "../javascripts/NgBuyersForm";
import UserDictionaryPreview from "../javascripts/UserDictionaryPreview";
// mall 固有 (qoo10/rakuten/au-pay) のコード分岐は mall_specific.js に集約
// application.jsx 自体はブランチ間で同一に保つ
import {
    MallPriceSettings,
    onCSVDownloadFormPrepared,
    onBulkPriceSettingFormSubmit,
    mallInit,
} from "../javascripts/mall_specific";

const render = (component, container) => {
    const root = createRoot(container);
    root.render(component);
}

// data-set 属性を引数として React コンポーネントを各要素にマウントするヘルパ
const mountComponentBySelector = (selector, factory) => {
    document.querySelectorAll(selector).forEach(elem => {
        render(factory(elem), elem);
    });
};

const showRenewalApiKeyModal = () => {
    const modalElement = document.getElementById('renewalApiKeyModal');
    if (!modalElement) return;
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
};

const showPriceSettings = () => {
    const element = document.getElementById('price-settings');
    if (element) {
        const data = element.getAttribute('data-settings');
        const url = element.getAttribute('data-url');
        const action = element.getAttribute('data-action') || 'PUT';
        render(<MallPriceSettings data={data} url={url} action={action} />, element);
    }
};

const showProductSearch = () => {
    document.querySelectorAll('.search-box').forEach((element) => {
        const url = element.getAttribute('data-url');
        const placeholder = element.getAttribute('data-placeholder');
        const q = element.getAttribute('data-q');
        render(<SearchBox url={url} placeholder={placeholder} q={q} />, element);
    });
    document.querySelectorAll('.filter-checkbox').forEach((element) => {
        const url = element.getAttribute('data-url');
        const name = element.getAttribute('data-name');
        const label = element.getAttribute('data-label');
        const value = element.getAttribute('data-value') === '1';
        render(<FilterCheckbox url={url} name={name} label={label} value={value} />, element);
    });
    mountComponentBySelector('.search-input', elem => <SearchInput {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-range', elem => <SearchRange {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-date-range', elem => <SearchDateRange {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-date', elem => <SearchDate {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-order', elem => <SearchOrder {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-submit', elem => <SearchSubmit {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-select', elem => <SearchSelect {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.search-category', elem => {
        const props = Object.assign({}, elem.dataset);
        props.categories = window.gon?.service_categories || '';
        return <SearchCategory {...props} />;
    });
    mountComponentBySelector('.remote-islands-form', elem => <RemoteIslandsForm {...Object.assign({}, elem.dataset)} />);
    mountComponentBySelector('.ng-buyers-form', elem => <NgBuyersForm {...Object.assign({}, elem.dataset)} />);
};

const showDatePickers = () => {
    document.querySelectorAll('.datepicker').forEach((element) => {
        const name = element.getAttribute('data-name');
        const value = element.getAttribute('data-value');
        render(<DatePicker name={name} value={value} />, element);
    });
};

const checkUserMailSettings = () => {
    const completeOrderModal = document.getElementById('complete-order');
    if (completeOrderModal) {
        completeOrderModal.addEventListener('shown.bs.modal', () => {
            Rails.ajax({
                type: 'POST', url: '/settings/check/mail-settings.js'
            });
        });
    }
};

const initToggleAll = () => {
    document.addEventListener('click', e => {
        const trigger = e.target.closest('.toggle-all');
        if (!trigger) return;
        const target = trigger.dataset.target;
        if (!target) return;
        document.querySelectorAll(target).forEach(el => { el.checked = trigger.checked; });
    });

    document.querySelectorAll('.with-toggle-all').forEach(el =>
        el.addEventListener('submit', (e) => {
            e.preventDefault();
            const form = el;
            document.querySelectorAll('.toggle-delete').forEach(input => {
                input.setAttribute('form', form.id);
            });
            showLoader();
            form.submit();
        }))
};

const mountCsvViewer = () => {
    const container = document.getElementById('csv-viewer');
    if (container) {
        render(<DataViewer />, container);
    }
};

const mountUserDictionaryPreview = () => {
    const container = document.getElementById('user-dictionary-preview');
    if (container) {
        render(<UserDictionaryPreview />, container);
    }
};

window.initMailTemplateSelect = () => {
    document.querySelectorAll('.mail-template-select').forEach((el) => {
        const id = el.getAttribute('data-id');
        const type = el.getAttribute('data-type');
        const name = el.getAttribute('data-name');
        let url = `/mail-templates/select.js?id=${id}&type=${type}&name=${name}`;
        const selected = el.getAttribute('data-selected');
        if (!isEmpty(selected)) {
            url += `&selected=${selected}`;
        }
        Rails.ajax({ type: 'GET', url });
    });
};
window.initOnMailTemplateSelect = () => {
    document.querySelectorAll('.mail-template-select-element').forEach((el) => {
        const showSelected = id => {
            const template = el.closest('.mail-template-select');
            const component_id = template?.dataset.id;
            const orderId = template?.dataset.order;
            Rails.ajax({ type: 'GET', url: `/mail-templates/select/${id}.js?order=${orderId}&component_id=${component_id}` });
        };
        const selected = el.dataset.selected;
        if (!isEmpty(selected)) {
            el.value = selected;
            showSelected(selected);
        }
        el.addEventListener('change', () => showSelected(el.value));
    });
};
window.initDeliveryCompanyCheckbox = () => {
    const select = document.querySelector('[name="order_info[use_delivery_company]"]');
    if (!select) return;
    const toggleSection = document.getElementById('delivery-company-mail-template-select');
    const notation = document.getElementById('use_delivery_company_notation');
    const toggle = () => {
        const checked = select.value === 'true';
        if (toggleSection) toggleSection.style.display = checked ? '' : 'none';
        if (notation) {
            notation.textContent = checked
                ? '配送業者に配送を委託します。Amazonの送り先は配送業者宛になっています。'
                : '配送を自分で行います。Amazonの送り先は自宅/自分の事務所となっています。';
        }
    };
    select.addEventListener('change', toggle);
    toggle();
};

const initCSVDownloadButton = () => {
    document.querySelectorAll('.bulk-action').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const form = document.getElementById('the-form');
            if (!form) return false;
            form.innerHTML = '';
            form.insertAdjacentHTML('beforeend', `<input type="hidden" name="authenticity_token" value="${csrfToken()}"/>`);
            form.insertAdjacentHTML('beforeend', `<input type="submit" value="submit"/>`);
            form.setAttribute('action', trigger.getAttribute('href'));
            form.style.display = 'none';
            onCSVDownloadFormPrepared(form, trigger);
            const checkedItemEls = document.querySelectorAll('.csv-item-check');
            let checkedItems = 0;
            checkedItemEls.forEach((el) => {
                if (el.checked) {
                    ++checkedItems;
                    form.insertAdjacentHTML('beforeend', `<input type="hidden" name="item[]" value="${el.dataset.id}"/>`);
                }
            });
            if (checkedItems === 0) {
                alert("チェックボックスが一つも選択されていません");
                return false;
            }
            form.submit();
            return false;
        });
    });
    const allTrigger = document.getElementById('bulk-action-all');
    if (allTrigger) {
        allTrigger.addEventListener('click', () => {
            document.querySelectorAll('.csv-item-check').forEach(el => { el.checked = allTrigger.checked; });
        });
    }
};

const initConversionPopup = () => {
    if (document.getElementById('conversion-popup')) {
        let __current_i = 0;
        document.querySelectorAll('.amazon-link').forEach((el, i) => {
            const openLink = () => {
                __current_i = i;
                const x = window.open(el.getAttribute('href'));
                setTimeout(function () {
                    x.close();
                }, (5 + 10 * Math.random()) * 2000);
            };
            if (i > 0) {
                setTimeout(openLink, i * 25000 + 10000 * Math.random());
            } else {
                openLink();
            }
        });
        window.getConversionCount = () => __current_i;
    }
};

const initAjax = () => {
    const loading = document.querySelector('.loading');
    if (!loading) return;

    const addClass = () => loading.classList.add('active');
    const removeClass = () => loading.classList.remove('active');

    // rails-ujs のグローバルイベントでローディング表示を切り替え
    document.addEventListener('ajax:send', addClass);
    document.addEventListener('ajax:complete', removeClass);
    document.addEventListener('ajax:error', removeClass);

    document.addEventListener('click', e => {
        if (e.target.dataset?.remote !== 'true') return;
        e.target.addEventListener("ajax:success", removeClass);
        addClass();
    });
};

const initSortable = async () => {
    const elements = document.querySelectorAll('.sortable');
    if (!elements.length) return;
    const { default: Sortable } = await import('sortablejs');
    elements.forEach(elem => Sortable.create(elem));
};

const initAmazonPriceInput = () => {
    document.querySelectorAll('.amazon-price-input').forEach(elem => {
        elem.addEventListener('click', () => {
            const currentPrice = elem.getAttribute('data-price');
            const itemName = elem.getAttribute('data-name');
            const price = prompt(`${itemName}Amazon仕入れ価格を変更`, currentPrice);
            const target = elem.getAttribute('data-target');
            Rails.ajax({
                type: 'POST', url: `/api/order-items/${target}/price`, data: new URLSearchParams({ price }).toString(),
                success: () => location.reload()
            });
        });
    });
};

const initSearchInput = () => {
    document.querySelectorAll('.js-search-query').forEach(elem => {
        elem.addEventListener('input', debounce(() => {
            Rails.ajax({
                type: 'GET', url: elem.closest('form').getAttribute('action'),
                data: new URLSearchParams({ q: elem.value }),
            })
        }, 800));
    });
};

const initOrderInfoCopy = () => {
    document.querySelectorAll('.copy-order-info').forEach(el => {
        el.addEventListener('click', () => {
            const prefecture = el.getAttribute('data-prefecture');
            let address1 = el.getAttribute('data-address1');
            address1 = address1.replace(new RegExp(`^${prefecture}`), '');
            const addressArr = chunk((el.getAttribute('data-address2')).split(''), 16);
            const address2 = (addressArr[0] || []).join('');
            const address3 = (addressArr[1] || []).join('');
            const address4 = (addressArr[2] || []).join('');
            const script = 'let i=(i,v)=>{e=document.querySelector(`.a-popover-inner ${i}`);if(e){e.value=v}};' +
                `i('input[name=address-ui-widgets-enterAddressFullName]','${normalizeKanji(el.getAttribute('data-name'))} ${el.getAttribute('data-order')}');` +
                `i('input[name=address-ui-widgets-enterAddressPhoneNumber]','${el.getAttribute('data-phone')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCodeOne]', '${el.getAttribute('data-zip1')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCodeTwo]','${el.getAttribute('data-zip2')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCode]', '${el.getAttribute('data-zip1')}-${el.getAttribute('data-zip2')}');` +
                `i('select[name=address-ui-widgets-enterAddressStateOrRegion]', '${prefecture}');` +
                `i('input[name=address-ui-widgets-enterAddressLine1]','${address1}');` +
                `i('input[name=address-ui-widgets-enterAddressLine2]','${address2}');` +
                `i('input[name=address-ui-widgets-enterBuildingOrCompanyName]', '${address3}');` +
                `i('input[name=address-ui-widgets-enterUnitOrRoomNumber]', '${address4}');` +
                `Array.from(document.querySelectorAll('.a-popover-inner .a-dropdown-prompt'))[1].textContent = '${prefecture}';alert('住所をセットしました！')`;
            copy(script).then(() => window.flash(`クリップボードに注文情報をコピーしました`));
        });
    });
};


const initPreferHistory = () => {
    document.querySelectorAll('.prefer-history').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            if (history.length > 1) {
                history.back();
            } else {
                history.pushState(null, null, el.getAttribute('href'));
            }
            return false;
        });
    });
};

const initEditSaveButton = () => {
    document.querySelectorAll('.edit-save-button-form').forEach(form => {
        const editButton = form.querySelector('.edit-button');
        const saveButton = form.querySelector('.save-button');
        const cancelButton = form.querySelector('.cancel-button');
        const readOnlyMemo = form.querySelector('.read-only-memo');
        const editableMemo = form.querySelector('.editable-memo');
        let editMode = false;
        const toggleForm = () =>
            form.querySelectorAll('input[type=text],textarea').forEach(() => {
                if (editMode) {
                    editableMemo?.classList.remove('d-none');
                    readOnlyMemo?.classList.add('d-none');
                } else {
                    readOnlyMemo?.classList.remove('d-none');
                    editableMemo?.classList.add('d-none');
                }
            });
        const toggleEdit = (e) => {
            e.preventDefault();
            editMode = !editMode;
            if (editMode) {
                saveButton?.classList.remove('d-none');
                cancelButton?.classList.remove('d-none');
                editButton?.classList.add('d-none');
            } else {
                editButton?.classList.remove('d-none');
                saveButton?.classList.add('d-none');
                cancelButton?.classList.add('d-none');
            }
            toggleForm();
            return false;
        };
        editButton?.addEventListener('click', toggleEdit);
        cancelButton?.addEventListener('click', toggleEdit);
        toggleForm();
    });
};

const initDomain = () => {
    // if (window.gon.signed_in && window.gon.app_domain !== location.host) {
    //     alert(`ツールのドメインは${window.gon.app_domain}に移動しました`)
    //     location.href = `//${window.gon.app_domain}`
    // }
};

const initBulkPriceSettingForm = () => {
    const form = document.querySelector('#bulk-price-setting-form');
    if (!form) {
        return;
    }
    form.addEventListener('submit', e => onBulkPriceSettingFormSubmit(form, e));
};

window.showWowmaCategories = () => {
    const element = document.getElementById('wowma-categories');
    if (element) {
        const selected = element.getAttribute('data-selected');
        const name = element.getAttribute('data-name');
        const service = element.getAttribute('data-service');
        const categories = window.gon.wowma_categories;
        render(<WowmaCategories selected={selected} name={name} categories={categories} service={service} />, element);
    }
};
window.showDatePickers = showDatePickers;

const onReady = () => {
    showRenewalApiKeyModal();
    window.showWowmaCategories();
    showPriceSettings();
    showProductSearch();
    showDatePickers();
    checkUserMailSettings();
    mountCsvViewer();
    mountUserDictionaryPreview();
    window.initMailTemplateSelect();
    window.initOnMailTemplateSelect();
    window.initDeliveryCompanyCheckbox();
    initToggleAll();
    initCSVDownloadButton();
    initConversionPopup();
    initAjax();
    initSortable();
    initAmazonPriceInput();
    initSearchInput();
    initOrderInfoCopy();
    initEditSaveButton();
    initDomain();
    initBulkPriceSettingForm();
    mallInit({ render });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
} else {
    onReady();
}
